
        import * as module0 from '$components/main.js'
        const modules = {
            "main.js": module0,
        };
        export default modules;
      